import { NgModule, ModuleWithProviders, APP_INITIALIZER, Optional } from '@angular/core';

import { googleMapInitializer } from './factories';
import { SN_GOOGLE_API_KEY, SN_GOOGLE_MAP_LIBRARY } from './providers';

@NgModule()
export class GoogleCoreModule {
  public static forRoot(apiKey: string): ModuleWithProviders<GoogleCoreModule> {
    return {
      ngModule: GoogleCoreModule,
      providers: [
        {
          provide: SN_GOOGLE_API_KEY,
          useValue: apiKey,
        },
        {
          provide: APP_INITIALIZER,
          useFactory: googleMapInitializer,
          deps: [SN_GOOGLE_API_KEY, [new Optional(), SN_GOOGLE_MAP_LIBRARY]],
          multi: true,
        },
      ],
    };
  }
}
